import { ChainId } from './chainId';
const INFURA_KEY = process.env.REACT_APP_INFURA_KEY;

export const RPC = {
  [ChainId.Mainnet]: `https://mainnet.infura.io/v3/${INFURA_KEY}`,
  [ChainId.BSC]: 'https://bsc-dataseed1.ninicoin.io',
  [ChainId.Rinkeby]: `https://rinkeby.infura.io/v3/${INFURA_KEY}`,
  [ChainId.BSCTestnet]: 'https://data-seed-prebsc-2-s2.binance.org:8545',
};
